/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Rule_Sets_UnderlineInputs */

const en_tables_rule_sets_underline = /** @type {(inputs: Tables_Rule_Sets_UnderlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets Underline`)
};

const de_tables_rule_sets_underline = /** @type {(inputs: Tables_Rule_Sets_UnderlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterstrichen`)
};

/**
* | output |
* | --- |
* | "Sets Underline" |
*
* @param {Tables_Rule_Sets_UnderlineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_rule_sets_underline = /** @type {((inputs?: Tables_Rule_Sets_UnderlineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Rule_Sets_UnderlineInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_rule_sets_underline(inputs)
	return de_tables_rule_sets_underline(inputs)
});